<template>
  <div class="container is-fluid has-text-centered">
  <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
  <br/>   
    <div v-if="urlValid === false">
      <h4>Welcome to Doodhvale, Please wait...</h4>
    </div>
    <div v-if="urlValid === true && salesman_otp_required === 0">
      <i class="fa fa-mobile icon"></i>
      <input v-model="userMobile" class="mobileOnDisp" id="mobile" maxlength="10" placeholder="Enter mobile number" required><br>
      <input style="margin-top: 3rem; margin-bottom: 3rem;" class="buttonOnRegFromDispatcher" value="CONTINUE" type="button" v-on:click="createUser();">
    </div>
    <div v-if="urlValid === true && salesman_otp_required === 1">
      <div v-if="otp === false">
      <br>
      <form style="margin-top: 20%;margin-bottom: 20%;">
        <div style="position: relative;">
          <i class="fa fa-mobile icon" style="margin-left: 15%"></i>
          <input class="mobile" id="mobile" maxlength="10" placeholder="Enter mobile number" required><br>
          <hr style="display: block; height: 1px; border: 0; border-top: 1px solid #3CB6C3; margin: 0em 15%; padding: 0; "><br>
        </div>
        <div class="w3-center">
          <input class="regbutton" value="NEXT" type="button" v-on:click="signup();">
        </div>
      </form>
    </div>
    <div v-if="otp">
      <br>
      <form style="margin-top: 20%;margin-bottom: 20%;">
        <div style="position: relative;">
          <i class="fa fa-mobile icon" style="margin-left: 15%"></i>
          <input class="mobile" id="mobile" maxlength="10" v-model="signUp.disMobile" disabled="true"><br>
          <hr style="display: block; height: 1px; border: 0; border-top: 1px solid #9a9a9a; margin: 0em 15%; padding: 0;"><br>
        </div>
        <div style="position: relative;">
          <img src="../../../../static/img/icon_otp.png" style="width:7%;margin-left: 15%">
          <input class="mobile" id="otp" maxlength="4" placeholder="Enter HAPPY CODE" required><br>
          <hr style="display: block; height: 1px; border: 0; border-top: 1px solid #212529; margin: 0em 15%; padding: 0;"><br>
        </div>
        <div class="w3-center">
          <input class="regbutton" value="REGISTER" type="button" v-on:click="verifyotp();">
        </div>
        <br>
        <div style="margin-left: 15%; margin-right: 15%; color: #11a4e0;">
          If you do not receive your HAPPY CODE within 1 minute, click the Resend HAPPY CODE button to resend code
        </div>
        <br>
        <div class="w3-center">
          <input class="regbutton" value="RESEND HAPPY CODE" type="button" v-on:click="resendotp();">
        </div>
      </form>
    </div>
  </div>

  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        urlInterface: [],
        apiDataObj: [],
        isFullPage: true,
        isLoading: true,
        urlValid: false,
        dispatcherId: 0,
        salesman_otp_required: 0,
        salesman_location_required: 0,
        otp: false,
        signUp: [],
        resendOtp: [],
        verifyOtp: [],
        masterOtp: 1234,
        userMobile: '',
        role: 4
      }
    },
    created () {
      sessionStorage.clear()
      this.fetchData()
    },
    methods: {
      fetchData () {
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('dispnewcust?')
        params.append('url_str', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.urlInterface.error_msg = response.data.msg
            this.urlValid = false
          } else {
            // this.urlValid = true
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
          }
          this.isLoading = false
          // console.log(response)
        })
        .catch(e => {
          alert('not ok')
        })
      },

      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // console.log(response)
          this.apiDataObj = {}
          switch (this.urlInterface.action_name) {
            case 'dispatcher_new_customer_flow':
              this.dispatcherId = response.data.action_response.dispatcher_id
              this.masterOtp = response.data.action_response.master_otp
              this.role = response.data.action_response.role
              this.urlValid = true
              this.salesman_otp_required = response.data.action_response.salesman_otp_required
              this.salesman_location_required = response.data.action_response.salesman_location_required
              sessionStorage.setItem('salesman_otp_required', response.data.action_response.salesman_otp_required)
              sessionStorage.setItem('role', this.role)
              sessionStorage.setItem('salesman_location_required', response.data.action_response.salesman_location_required)
              sessionStorage.setItem('dispatcherId', this.dispatcherId)
              sessionStorage.setItem('salesman_flow', response.data.action_response.salesman_flow)
              break
            default:
              break
          }
          this.isLoading = false
        })
        .catch(e => {
          alert('not ok')
        })
      },
      signup () {
        const params = new URLSearchParams()
        var mobile = document.getElementById('mobile').value
        var deviceID = document.getElementById('mobile').value
        if (isNaN(mobile) || mobile.length !== 10 || mobile === '') {
          alert('Oops! Invalid Mobile Number.')
        } else {
          params.append('mobile', mobile)
          params.append('deviceId', deviceID)
          params.append('flow_type', 'salesman')
          axios({
            url: process.env.BASE_API + '/users/signup',
            method: 'post',
            data: params,
            withCredentials: false,
            headers: {
            }
          })
          .then(response => {
            this.signUp = {}
            if (response.data.status === '000000' || response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000007' || response.data.status === '000012') {
              this.signUp.disMobile = mobile
              this.otp = true
              if (response.data.status === '000000' && response.data.is_profile === 1) {

              } else {
                this.resendotp()
              }
            } else {
              alert(response.data.msg)
            }
            // console.log(response)
            if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              this.list = response.data.user_record
              alert(this.list)
            }
          })
          .catch(e => {
            alert('not ok')
          })
        }
      },
      resendotp () {
        const params = new URLSearchParams()
        params.append('mobile', this.signUp.disMobile)
        params.append('deviceId', this.signUp.disMobile)
        params.append('flow_type', 'salesman')
        axios({
          url: process.env.BASE_API + '/users/resend-otp',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.resendOtp = {}
          if (response.data.status !== '000000') {
            alert(response.data.msg)
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },
      verifyotp () {
        const params = new URLSearchParams()
        var otp = document.getElementById('otp').value
        var mobile = this.signUp.disMobile
        var deviceID = this.signUp.disMobile
        if (isNaN(otp) || otp.length !== 4 || otp === '') {
          alert('Oops! Invalid OTP.')
        } else {
          params.append('otp', otp)
          params.append('mobile', mobile)
          params.append('deviceId', deviceID)
          axios({
            url: process.env.BASE_API + '/users/verify-otp',
            method: 'post',
            data: params,
            withCredentials: false,
            headers: {
            }
          })
          .then(response => {
            this.verifyOtp = {}
            if (response.data.status === '000000') {
              /* this.verifyOtp.userId = response.data.user_id
              this.verifyOtp.roleId = response.data.role_id
              this.verifyOtp.isProfile = response.data.is_profile
              this.verifyOtp.userMobile = response.data.user_mobile */
              sessionStorage.setItem('userId', response.data.user_id)
              sessionStorage.setItem('roleId', response.data.role_id)
              sessionStorage.setItem('isProfile', response.data.is_profile)
              sessionStorage.setItem('userMobile', response.data.user_mobile)
              if (response.data.is_profile === 0) {
                if (sessionStorage.getItem('urlstr') === 'undefined' || sessionStorage.getItem('urlstr') === null) {
                  // this.$router.push('/a/subscription')
                  sessionStorage.setItem('productListUrl', response.data.product_list_url)
                  window.location.href = response.data.product_list_url
                } else {
                  this.$router.push('/a/s?' + sessionStorage.getItem('urlstr'))
                }
              } else {
                this.$router.push('/a/location')
              }
            } else {
              alert(response.data.msg)
            }
            // console.log(response)
            if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              this.list = response.data.user_record
              alert(this.list)
            }
          })
          .catch(e => {
            alert('not ok')
          })
        }
      },
      createUser () {
        const params = new URLSearchParams()
        var otp = this.masterOtp
        var mobile = this.userMobile
        var deviceID = this.userMobile
        if (isNaN(mobile) || mobile.length !== 10 || mobile === '') {
          alert('Oops! Invalid Mobile Number.')
        } else {
          this.$swal({
            text: 'Are you sure? Customer mobile no is ' + mobile,
            showCancelButton: true,
            confirmButtonText: 'Cancel',
            cancelButtonText: 'OK',
            cancelButtonColor: '#3CB6C3',
            confirmButtonColor: '#e55a5a'
          }).then((result) => {
            if (result.value) {
              // this.$swal('Success', 'Thanks you Cancel!', 'success')
            } else {
              params.append('mobile', mobile)
              params.append('deviceId', deviceID)
              params.append('dispatcher_id', this.dispatcherId)
              params.append('flow_type', 'dispatcher')
              axios({
                url: process.env.BASE_API + '/users/signup',
                method: 'post',
                data: params,
                withCredentials: false,
                headers: {
                }
              })
              .then(response => {
                this.signUp = {}
                if (response.data.status === '000000' || response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000007' || response.data.status === '000012') {
                  params.append('otp', otp)
                  params.append('mobile', mobile)
                  params.append('deviceId', deviceID)
                  params.append('flow_type', 'dispatcher')
                  axios({
                    url: process.env.BASE_API + '/users/verify-otp',
                    method: 'post',
                    data: params,
                    withCredentials: false,
                    headers: {
                    }
                  })
                  .then(response => {
                    // console.log(this.dispatcherId)
                    // console.log(response)
                    this.verifyOtp = {}
                    if (response.data.status === '000000') {
                      sessionStorage.setItem('userId', response.data.user_id)
                      sessionStorage.setItem('roleId', response.data.role_id)
                      sessionStorage.setItem('isProfile', response.data.is_profile)
                      sessionStorage.setItem('userMobile', response.data.user_mobile)
                      sessionStorage.setItem('blockNewCustByDispatcher', response.data.block_new_cust_by_dispatcher)
                      sessionStorage.setItem('dispatcherId', this.dispatcherId)
                      sessionStorage.setItem('role', this.role)
                      // console.log(response.data.dispatcher_id)
                      if (parseInt(response.data.dispatcher_id) !== parseInt(this.dispatcherId) && (sessionStorage.getItem('role') === 4 || sessionStorage.getItem('role') === '4')) {
                        // this.$swal.fire('Sorry! This customer is not in your circle')
                        this.$swal.fire({text: 'Sorry! This customer is not in your circle'})
                      } else if (response.data.block_new_cust_by_dispatcher === 1 && response.data.is_profile === 0) {
                        // this.$swal.fire('Customer Already registered, You can create only new customer!')
                        this.$swal.fire({text: 'Customer Already registered, You can create only new customer!'})
                      } else if (response.data.is_profile === 0) {
                        // send directly to productList
                        sessionStorage.setItem('productListUrl', response.data.product_list_url)
                        window.location.href = response.data.product_list_url
                        // window.location.href = 'http://localhost:4000/#/a/productList?4t44'
                      } else {
                        // create profile
                        this.$router.push('/a/location')
                      }
                      /* if (response.data.is_profile === 0) {
                        if (sessionStorage.getItem('urlstr') === 'undefined' || sessionStorage.getItem('urlstr') === null) {
                          this.$router.push('/a/subscription')
                        } else {
                          this.$router.push('/a/s?' + sessionStorage.getItem('urlstr'))
                        }
                      } else {
                        this.$router.push('/a/location')
                      } */
                    } else {
                      alert(response.data.msg)
                    }
                    // console.log(response)
                  })
                  .catch(e => {
                    alert('not ok')
                  })
                } else {
                  alert(response.data.msg)
                }
                // console.log(response)
              })
              .catch(e => {
                alert('not ok')
              })
            }
          })
          /* alert(otp)
          alert(mobile)
          alert(deviceID) */
        }
      }
    }
  }
</script>
<style>
.loading-icon:before {content: "Wait...";}
.loading-overlay .loading-icon:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #3CB6C3;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 1em;
  position: relative;
  width: 1em;
  position: absolute;
  top: calc(50% - 1.5em);
  left: calc(50% - 1.5em);
  width: 3em;
  height: 3em;
  border-width: 0.25em;
}
.mobile {background-color: transparent; border: 0px solid; padding-bottom: 1%;font-size: 20px;}
.regbutton {background-color: #3CB6C3;width: 70%; padding: 3% 3% 3% 0%;}
.icon {font-size: xx-large; width: 25px;}
.mobileOnDisp {background-color: transparent; border: 0px solid; padding-bottom: 1%;font-size: 20px; width: 65%;}
.icon {font-size: xx-large; width: 25px;}
.buttonOnRegFromDispatcher {
  background-color: #3CB6C3;
  padding: 2% 17% 2% 18%;
  width: 75%;
  color: white;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dispnewcust.vue